import { createElement } from "react";
import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { requirePermission } from "../../../../shared/routing/requirePermission";
import { GPRS_VIEW } from "../../gprsPermissions";
import type { GprsRouteFactory } from "./gprsRouteContext";
import { gprsCommandsSearchSchema } from "./searchSchemas";

const GprsListScreen = lazyRouteComponent(
  () => import("../GprsListScreen"),
  "GprsListScreen",
);

// Command details open as a dialog over the list (GprsCommandDetailDialog),
// so there's no separate '$id' route.
export const createGprsListRoutes: GprsRouteFactory = ({
  context,
  gprsCommands,
  companies,
  devices,
}) => [
  createRoute({
    getParentRoute: context.getParentRoute,
    path: context.basePath,
    validateSearch: gprsCommandsSearchSchema,
    beforeLoad: requirePermission([GPRS_VIEW]),
    component: () =>
      createElement(GprsListScreen, {
        repository: gprsCommands,
        basePath: context.basePath,
        companies,
        devices,
      }),
  }),
];
